var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-badge',{staticClass:"mark",attrs:{"value":_vm.text,"type":_vm.badgeType}})}
var staticRenderFns = []

export { render, staticRenderFns }